import {FPNetDate, IndiceMese, ObjectFactory, TabellaGenerica} from "@commons/types";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {LavoratorePresenzeProprietaULRecord, TipoRilevazionePresenze} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {LavoratoreStatusRecord} from "@commons/mapping/LavoratoreStatusRecord";
import {LavoratoreProprietaOrarioRecord} from "@commons/mapping/LavoratoreProprietaOrarioRecord";
import {DateTime} from "luxon";
import {SituazioneIC} from "@commons/services/presenze_calcolo/SituazioneIC";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {GiustificativoAttestatoINPSRecord} from "@commons/mapping/GiustificativoAttestatoINPSRecord";
import {StatoWeekPLUSRecord} from "@commons/mapping/StatoWeekPLUSRecord";
import {GestionePlusData} from "@commons/services/presenze_calcolo/GestionePlusData";
import {AziendaBase} from "@commons/mapping/AziendaNavRecord";
import {merge} from "lodash";

export type MansioneRecord = TabellaGenerica | null;
export type CategoriaRecord = TabellaGenerica | null;
export type LivelloRecord = TabellaGenerica | null;

export interface LavoratorePresenzeRecord extends LavoratoreBase, GestionePlusData {
    azienda: AziendaBase | null,

    codDip: number | null,
    codDipPaghe: number | null,
    dataAssunzione: FPNetDate,
    dataAssConvenzionale: FPNetDate,
    dataFineTDET: FPNetDate,
    dataCessazione: FPNetDate,
    mansione: MansioneRecord,
    qualifica: CategoriaRecord,
    livello: LivelloRecord,
    partitaIvaPromotore: string | null,
    denominazionePromotore: string | null,
    codContrattoUNILAV: string | null,
    codTipologiaContratto: string | null,
    codTipologiaOrario: string | null,
    sesso: string | null,

    tipoRilevazione: TipoRilevazionePresenze,
    //proprietaOrario: ProprietaOrario,
    anomalia: boolean,
    hasMalattia: boolean,
    hasWF: boolean,
    //hasPianificazione: boolean,
    codCDIC: string,
    presenteDa: FPNetDate,
    presenteA: FPNetDate,

    proprieta: LavoratorePresenzeProprietaULRecord[] | null, // [] di LavoratorePresenzeProprieta
    status: LavoratoreStatusRecord[] | null, // [] di LavoratoreStatus
    orarioProprieta: LavoratoreProprietaOrarioRecord[] | null, // [] di LavoratoreOrarioProprieta

    // NEW 2023
    anno: number,
    mese: IndiceMese,
    ic: SituazioneIC | null; // SituazioneIC
    days: PresenzeGiornataPlusRecord[] | null;
    weeks: StatoWeekPLUSRecord[] | null;
    totaliMese: StatoWeekPLUSRecord | null;

    causaliWF: PresenzeCausaleWFRecord[];
    //vociPianificazione: PresenzePianificazioneRecord[];
    giustificativiAttestati: GiustificativoAttestatoINPSRecord[];

    loaded: boolean; // Indica che per il lavoratore sono gia state caricare le presenze in precedenza


    codQualifica: string; // Char(10)

    codMansione: string; // Char(10)
    codRuolo: string; // Char(10)

    codGruppo1: string; // Char(10)
    codGruppo2: string; // Char(10)
    codGruppo3: string; // Char(10)
    codGruppo4: string; // Char(10)
    codGruppo5: string; // Char(10)
    codGruppo6: string; // Char(10)
    codGruppo7: string; // Char(10)
    codGruppo8: string; // Char(10)
    codGruppo9: string; // Char(10)
    codGruppo10: string; // Char(10)
    codGruppo11: string; // Char(10)
    codGruppo12: string; // Char(10)
}

export class LavoratorePresenzeRecord {
    static factory: ObjectFactory<LavoratorePresenzeRecord> = (json?) => {

        return merge<LavoratorePresenzeRecord, Partial<LavoratorePresenzeRecord> | undefined>({
            idAziendaMaster: 0,
            idAzienda: 0,
            id: 0, // id dip, identifica unicamente il lavoratore/contratto a livello di database
            nome: null,
            cognome: null,
            descrizione: null, // semplicemente cognome+' '+nome
            codiceFiscale: '',
            matricola: null,
            countXUL: null,
            azienda: null,

            codDip: null,
            codDipPaghe: null,
            dataAssunzione: null,
            dataAssConvenzionale: null,
            dataFineTDET: null,
            dataCessazione: null,
            mansione: {} as MansioneRecord,
            qualifica: {} as CategoriaRecord,
            livello: {} as LivelloRecord,
            partitaIvaPromotore: null,
            denominazionePromotore: null,
            codContrattoUNILAV: null,
            codTipologiaContratto: null,
            codTipologiaOrario: null,
            sesso: null,

            tipoRilevazione: {} as TipoRilevazionePresenze,
            //proprietaOrario: ProprietaOrario,
            anomalia: false,
            hasMalattia: false,
            hasWF: false,
            //hasPianificazione: boolean,
            codCDIC: '',
            presenteDa: null,
            presenteA: null,

            proprieta: null, // [] di LavoratorePresenzeProprieta
            status: null, // [] di LavoratoreStatus
            orarioProprieta: null, // [] di LavoratoreOrarioProprieta

            anno: 0,
            mese: 1,
            ic: null, // SituazioneIC
            days: null,
            weeks: null,
            totaliMese: null,

            causaliWF: [],
            //vociPianificazione: PresenzePianificazioneRecord[];
            giustificativiAttestati: [],

            loaded: false,


            codQualifica: '',

            codMansione: '',
            codRuolo: '',

            codGruppo1: '',
            codGruppo2: '',
            codGruppo3: '',
            codGruppo4: '',
            codGruppo5: '',
            codGruppo6: '',
            codGruppo7: '',
            codGruppo8: '',
            codGruppo9: '',
            codGruppo10: '',
            codGruppo11: '',
            codGruppo12: '',
            soloMeseRif: false,
            causaliWFElaborate: [],
            giustificativiAttestatiElaborati: [],

            proprietaOrario: null,

            // Aggiorno elenco stati e proprietà di gestione
            elencoStatus: [],
            proprietaGestione: null,

            calendarioChiusure: null,

            elencoTurni: [],
            turnoAConsuntivo: null,

            tabFlex: null,
            tabQualificaEcc: null,
            tabQuantificaEcc: null,
            distribuzioneTurno: null,

        }, json);
    }

    static getNominativo = (lavoratore: Pick<LavoratorePresenzeRecord, 'descrizione' | 'cognome' | 'nome'>) => {
        if (lavoratore.descrizione !== null) {
            return lavoratore.descrizione;
        } else {
            return lavoratore.cognome + ' ' + lavoratore.nome;
        }
    }

    static getDescrizione = (lavoratore: Pick<LavoratorePresenzeRecord, 'codDip' | 'descrizione' | 'cognome' | 'nome' | 'dataCessazione'>, addDTCessazione: boolean = false) => {
        if (addDTCessazione) {
            return `${LavoratorePresenzeRecord.getNominativo(lavoratore)} (${LavoratorePresenzeRecord.getDtCess(lavoratore)})`;
        } else {
            return LavoratorePresenzeRecord.getNominativo(lavoratore) + (lavoratore.codDip ? ` [${lavoratore.codDip}]` : '');
        }

    }

    static getDtCess = (lavoratore: Pick<LavoratorePresenzeRecord, 'dataCessazione'>, format: string = 'dd/LL/yyyy'): string => {
        return !lavoratore.dataCessazione ? '' : DateTime.fromISO(lavoratore.dataCessazione).toFormat(format);
    }

    static getStatus = (lavoratore: Pick<LavoratorePresenzeRecord, 'status'>, decorrenza: FPNetDate): LavoratoreStatusRecord[] => {
        const status: LavoratoreStatusRecord[] = [];
        if (lavoratore.status && lavoratore.status.length)
            for (const prop of lavoratore.status) {
                if (DateTime.fromISO(prop.decorrenza!) <= DateTime.fromISO(decorrenza!) &&
                    (!prop.fineValidita || DateTime.fromISO(prop.fineValidita) >= DateTime.fromISO(decorrenza!))
                ) {
                    status.push(prop);
                }
            }
        return status;
    }

    static hasPianificazione = (_p: LavoratorePresenzeRecord) => {
        return true; // todo ???
    }

    static hasAnomalie = (p: LavoratorePresenzeRecord) => {
        return p.anomalia;
    }

    /**
     * Restituisce l'oggetto LavoratorePresenzeProprietaULRecord valido per il giorno indicato
     * @param params
     * @param decorrenza
     */
    static getProprieta = (params: Pick<LavoratorePresenzeRecord, 'proprieta'>, decorrenza: DateTime): LavoratorePresenzeProprietaULRecord | null => {
        let proprieta = null;
        //console.warn('params.proprieta',params.proprieta)
        if (params.proprieta && params.proprieta.length) {
            for (let ind0 = params.proprieta.length - 1; ind0 >= 0; --ind0) {
                const prop = params.proprieta[ind0];
                const propDecorrenza = DateTime.fromISO(prop.decorrenza!);
                if (propDecorrenza <= decorrenza) {
                    proprieta = prop;
                    break;
                }
            }
        }
        return proprieta;
    }

    static getOrarioProprieta = (params: Pick<LavoratorePresenzeRecord, 'orarioProprieta'>, decorrenza: DateTime) => {
        let proprieta = null;
        if (params.orarioProprieta && params.orarioProprieta.length) {
            for (let ind0 = params.orarioProprieta.length - 1; ind0 >= 0; --ind0) {
                const prop = params.orarioProprieta[ind0];
                const propDecorrenza = DateTime.fromISO(prop.decorrenza!);
                if (propDecorrenza <= decorrenza) {
                    proprieta = prop;
                    break;
                }
            }
        }
        return proprieta;
    }

    static isHiredBetween = (lavoratore: Pick<LavoratorePresenzeRecord, 'dataAssunzione'>, dtInizio: FPNetDate, dtFine: FPNetDate, includiEstremi: boolean = true) => {
        const dtInizioWeek = DateTime.fromISO(dtInizio!).startOf('day');
        const dtFineWeek = DateTime.fromISO(dtFine!).endOf('day');
        const dtAssunzione = DateTime.fromISO(lavoratore.dataAssunzione!).startOf('day');
        if (includiEstremi) {
            return (dtAssunzione.toMillis() >= dtInizioWeek.toMillis() && dtAssunzione.toMillis() <= dtFineWeek.toMillis());
        } else {
            return (dtAssunzione.toMillis() > dtInizioWeek.toMillis() && dtAssunzione.toMillis() < dtFineWeek.toMillis());
        }
    }

    static isFiredBetween = (lavoratore: Pick<LavoratorePresenzeRecord, 'dataCessazione'>, dtInizio: FPNetDate, dtFine: FPNetDate, includiEstremi: boolean = true) => {
        if (!lavoratore.dataCessazione)
            return false;
        else {
            const dtInizioWeek = DateTime.fromISO(dtInizio!).startOf('day');
            const dtFineWeek = DateTime.fromISO(dtFine!).endOf('day');
            const dtCessazione = DateTime.fromISO(lavoratore.dataCessazione!).endOf('day');
            if (includiEstremi) {
                return (dtCessazione.toMillis() >= dtInizioWeek.toMillis() && dtCessazione.toMillis() <= dtFineWeek.toMillis());
            } else {
                return (dtCessazione.toMillis() > dtInizioWeek.toMillis() && dtCessazione.toMillis() < dtFineWeek.toMillis());
            }
        }
    }

    static isFired = (contratto: Pick<LavoratorePresenzeRecord, 'dataCessazione'> | null, dtRiferimento: DateTime = DateTime.now()): boolean => {
        if (!contratto) {
            throw new Error('contratto è null!');
        }
        if (!contratto.dataCessazione)
            return false;
        const dtCessazione = DateTime.fromISO(contratto.dataCessazione);
        return dtCessazione.startOf('day') < dtRiferimento.startOf('day');
    }

    static isActive = (contratto: LavoratorePresenzeRecord, dtRiferimento: FPNetDate): boolean => {
        if (!contratto) {
            throw new Error('contratto è null!');
        }
        return !contratto.dataCessazione || DateTime.fromISO(contratto.dataCessazione).startOf('day') >= DateTime.fromISO(dtRiferimento!).startOf('day');
    }

    static isHired = (contratto: Pick<LavoratorePresenzeRecord, 'dataAssunzione'> | null, dtGiornata: FPNetDate) => {
        if (contratto && (dtGiornata && contratto.dataAssunzione)) {
            let dataAssunzioneNew = DateTime.fromISO(contratto.dataAssunzione).startOf('day').toMillis();
            let dtGiornataNew = DateTime.fromISO(dtGiornata).startOf('day').toMillis();
            return (dataAssunzioneNew <= dtGiornataNew);
        } else {
            return false;
        }
    }

    static isPresenteIl = (contratto: Pick<LavoratorePresenzeRecord, 'dataAssunzione' | 'dataCessazione'> | null, dtGiornata: FPNetDate) => {
        const hired = LavoratorePresenzeRecord.isHired(contratto, dtGiornata);
        const fired = LavoratorePresenzeRecord.isFired(contratto, DateTime.fromISO(dtGiornata!))
        return hired && !fired;
    };
}